import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { setActiveStudent, setActiveSchool } from 'actions/user';
import { getProfileInformation, putProfileInformation } from 'actions/profile';
import { getUnreadNotifications } from 'actions/notifications';
import swal from 'sweetalert2';
import { Icon, Menu, translate, getActiveLanguage } from '@haldor/ui';
import { languages, setLanguage, getLanguage } from './LanguageManager';
import './index.scss';
var AppMenu = /*#__PURE__*/function (_Component) {
  function AppMenu() {
    var _this;
    _classCallCheck(this, AppMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AppMenu, [].concat(args));
    _defineProperty(_this, "componentDidMount", function () {});
    _defineProperty(_this, "switchStudent", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(student) {
        var index;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.setActiveStudent(student)["catch"](function (e) {});
            case 2:
              if (_context.sent) {
                _context.next = 7;
                break;
              }
              // inactive student
              // Remove student from list
              index = _this.props.students.findIndex(function (s) {
                return s.id == student.id;
              });
              if (index > -1) {
                _this.props.students.splice(index, 1); // Remove student
              }

              // Show error message
              swal({
                title: _this.props.translate('Inactive student'),
                text: _this.props.translate('This student is inactive. If that´s incorrect, please contact your school'),
                confirmButtonText: _this.props.translate('ok')
              }).then(function () {
                _this.props.history.push("/"); //Navigate home, to trigger update of students in the menu
              });
              return _context.abrupt("return");
            case 7:
              student = _this.props.activeStudent;
              _context.next = 10;
              return _this.props.setActiveSchool(student.schools[0].id, student.id);
            case 10:
              _this.props.history.push("/switchschool");
              _this.props.getUnreadNotifications(_this.props.activeStudent.id);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "switchSchool", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(school, userId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.props.setActiveSchool(school, userId);
            case 2:
              _this.props.history.push("/switchschool");
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "getBadgeForItem", function (item) {
      if (_this.props.unreadNotifications != null) {
        if (item.url == '/conversations') {
          if (_this.props.unreadNotifications.conversations != null && parseInt(_this.props.unreadNotifications.conversations) > 0) {
            return _this.props.unreadNotifications.conversations;
          }
        }
        if (item.url == '/notifications') {
          if (_this.props.unreadNotifications.events != null && parseInt(_this.props.unreadNotifications.events) > 0) {
            return _this.props.unreadNotifications.events;
          }
        }
        if (item.url == '/posts') {
          if (_this.props.unreadNotifications.posts != null && parseInt(_this.props.unreadNotifications.posts) > 0 || _this.props.unreadNotifications.documentations != null && parseInt(_this.props.unreadNotifications.documentations) > 0) {
            var _this$props$unreadNot, _this$props$unreadNot2;
            return ((_this$props$unreadNot = _this.props.unreadNotifications.posts) !== null && _this$props$unreadNot !== void 0 ? _this$props$unreadNot : 0) + ((_this$props$unreadNot2 = _this.props.unreadNotifications.documentations) !== null && _this$props$unreadNot2 !== void 0 ? _this$props$unreadNot2 : 0);
          }
        }
      }
      return null;
    });
    _defineProperty(_this, "linkTexts", function (value) {
      switch (value) {
        case "NAV_HOME":
          return _this.props.translate('Home');
          break;
        case "NAV_SCHEDULE":
          return _this.props.translate('Schedule');
          break;
        case "NAV_POSTS":
          return _this.props.translate('Posts');
          break;
        case "NAV_ASSIGNMENTS":
          return _this.props.translate('Assignments');
          break;
        case "NAV_PLANS":
          return _this.props.translate('Plans');
          break;
        case "NAV_MESSAGES":
          return _this.props.translate('Messages');
          break;
        case "NAV_NOTIFICATIONS":
          return _this.props.translate('Events');
          break;
        case "NAV_FORMS":
          return _this.props.translate('Forms');
          break;
        case "NAV_MEETINGS":
          return _this.props.translate('Parent-teacher meeting');
          break;
        case "NAV_ABSENCE":
          return _this.props.translate('Absence');
          break;
        case "NAV_ATTENDANCE":
          return _this.props.translate('Attendance');
          break;
        case "NAV_COURSES":
          return _this.props.translate('Courses');
          break;
        case "NAV_GROUPS":
          return _this.props.translate('Groups');
          break;
        case "NAV_ABSENCE":
          return _this.props.translate('Absence');
          break;
        case "NAV_PROGRESS":
          return _this.props.translate('Progress');
          break;
        default:
          return value;
          break;
      }
    });
    _defineProperty(_this, "categoryText", function (value) {
      switch (value) {
        case "EDUCATION":
          return _this.props.translate('Education');
          break;
        case "MENTOR":
          return _this.props.translate('Mentor');
          break;
        case "ADMINISTRATION":
          return _this.props.translate('Administration');
          break;
        default:
          return value;
          break;
      }
    });
    _defineProperty(_this, "getUserMenu", function () {
      var translate = _this.props.translate;
      var userMenu = [];
      userMenu.push({
        onClick: function onClick() {
          return _this.props.history.push("/profile");
        },
        onKeyDown: function onKeyDown(event) {
          event.key == "Enter" ? event.target.click() : null;
        },
        label: /*#__PURE__*/React.createElement("div", {
          tabIndex: 0,
          style: {
            textDecoration: "none",
            color: "inherit"
          }
        }, translate('Your information'))
      });
      userMenu.push({
        onClick: function onClick() {
          return _this.props.history.push("/logout");
        },
        onKeyDown: function onKeyDown(event) {
          event.key == "Enter" ? event.target.click() : null;
        },
        label: /*#__PURE__*/React.createElement("div", {
          tabIndex: 0,
          style: {
            textDecoration: "none",
            color: "inherit"
          }
        }, translate('Sign out'))
      });
      return userMenu;
    });
    _defineProperty(_this, "getLanguageMenu", function () {
      var languageMenu = [];
      languages().forEach(function (language) {
        languageMenu.push({
          onKeyDown: function onKeyDown(event) {
            event.key == "Enter" ? event.target.click() : null;
          },
          onClick: function onClick() {
            return setLanguage(language.lcid, _this.props.profile);
          },
          label: getActiveLanguage().toLowerCase() == language.lcid.toLowerCase() ? /*#__PURE__*/React.createElement("div", {
            style: {
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between"
            }
          }, /*#__PURE__*/React.createElement("span", {
            tabIndex: 0,
            style: {
              display: "flex",
              alignItems: "center"
            }
          }, /*#__PURE__*/React.createElement("img", {
            style: {
              height: "14px",
              width: "20px",
              objectFit: "cover",
              marginRight: "10px",
              borderRadius: "2px"
            },
            alt: language.label,
            src: language.svg_src
          }), " ", language.label), /*#__PURE__*/React.createElement(Icon, {
            name: "check",
            style: {
              marginLeft: "1rem"
            }
          })) : /*#__PURE__*/React.createElement("span", {
            tabIndex: 0,
            style: {
              display: "flex",
              alignItems: "center"
            }
          }, /*#__PURE__*/React.createElement("img", {
            style: {
              height: "14px",
              width: "20px",
              objectFit: "cover",
              marginRight: "10px",
              borderRadius: "2px"
            },
            alt: language.label,
            src: language.svg_src
          }), " ", language.label)
        });
      });
      return languageMenu;
    });
    return _this;
  }
  _inherits(AppMenu, _Component);
  return _createClass(AppMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$props$activeStu,
        _this$props$activeStu2,
        _this$props$activeStu3,
        _this$props$activeStu4;
      var _this$props = this.props,
        activeSchool = _this$props.activeSchool,
        activeStudent = _this$props.activeStudent,
        translate = _this$props.translate,
        profile = _this$props.profile;
      var students = [];
      var schools = [];
      var categories = [];
      var schoolTitle = '';
      var userMenu = this.getUserMenu();
      var languageMenu = this.getLanguageMenu();
      var displayActiveLanguage = getLanguage();
      var notCurrentStudentHaveUnreads = false;
      if (this.props.students.length > 1) {
        if (this.props.unreadNotifications != null && this.props.unreadNotifications.notificationsPerStudent != null && this.props.unreadNotifications.notificationsPerStudent.length > 0) {
          notCurrentStudentHaveUnreads = this.props.unreadNotifications.notificationsPerStudent.find(function (n) {
            return n.studentId !== _this2.props.activeStudent.id && n.unreadMessages > 0;
          }) || false;
        }
        this.props.students.forEach(function (student) {
          var label = "".concat((student === null || student === void 0 ? void 0 : student.firstName) || '', " ").concat((student === null || student === void 0 ? void 0 : student.lastName) || '').trim();
          var haveUnreads = false;

          // Find out if user have unread conversations/posts/documentaions on current child/student
          if (_this2.props.unreadNotifications != null && _this2.props.unreadNotifications.notificationsPerStudent != null && _this2.props.unreadNotifications.notificationsPerStudent.length > 0) {
            haveUnreads = _this2.props.unreadNotifications.notificationsPerStudent.find(function (n) {
              return n.studentId === student.id && n.unreadMessages > 0;
            }) || false;
          }
          var badge = haveUnreads ? /*#__PURE__*/React.createElement("span", {
            className: "badge",
            style: {
              display: 'inline-flex',
              justifyContent: 'center',
              transform: 'none',
              borderRadius: '100%',
              position: 'static',
              margin: '0 0 0.2rem 0.4rem',
              width: '18px',
              height: '18px'
            }
          }) : null;
          if (student.id == _this2.props.student.id) {
            label = /*#__PURE__*/React.createElement("span", {
              tabIndex: 0,
              style: {
                fontWeight: "bold"
              }
            }, label, " ", /*#__PURE__*/React.createElement(Icon, {
              style: {
                marginLeft: "1rem"
              },
              name: "check"
            }), " ");
          } else {
            label = /*#__PURE__*/React.createElement("span", {
              tabIndex: 0,
              style: {
                display: 'flex',
                alignItems: 'center'
              }
            }, label, " ", badge);
          }
          students.push({
            label: label,
            onClick: function onClick() {
              return _this2.switchStudent(student);
            },
            onKeyDown: function onKeyDown(event) {
              event.key == "Enter" ? event.target.click() : null;
            }
          });
        });
      }
      this.props.student.schools.forEach(function (school) {
        var title = school.title;
        if (school.id == activeSchool) {
          schoolTitle = title;
          title = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
            name: "check"
          }), " ", title);
        }
        schools.push({
          label: title,
          onClick: function onClick() {
            return _this2.switchSchool(school.id, activeStudent.id);
          }
        });
      });
      if (this.props.items != null) {
        this.props.items.forEach(function (item) {
          if (item.parentId != null && item.parentId != '') {
            if (categories.indexOf(item.parentId) == -1) {
              categories.push(item.parentId);
            }
          }
        });
      }
      return /*#__PURE__*/React.createElement(Menu, null, this.props.items != null ? this.props.items.map(function (item, index) {
        if (item.parentId != null && item.parentId != '') {
          return null;
        }
        if (item.type == 'EXTERNAL') {
          return null;
        }
        return /*#__PURE__*/React.createElement(Menu.Item, {
          key: 'item-' + index,
          label: _this2.linkTexts(item.text),
          Link: Link,
          to: item.url,
          icon: /*#__PURE__*/React.createElement(Icon, {
            name: item.iconId
          }),
          exact: true,
          badge: _this2.getBadgeForItem(item),
          onClick: item.url == '/' ? function () {
            return _this2.props.getUnreadNotifications(_this2.props.activeStudent.id);
          } : null
        });
      }) : null, categories.map(function (category, catindex) {
        return /*#__PURE__*/React.createElement(Menu.Divider, {
          key: 'divider' + catindex,
          label: _this2.categoryText(category.text)
        }, _this2.props.items.map(function (item, index) {
          if (item.parentId != null && item.parentId == category) {
            return /*#__PURE__*/React.createElement(Menu.Item, {
              key: 'item-' + index,
              label: _this2.linkTexts(item.text),
              Link: Link,
              to: item.url,
              icon: /*#__PURE__*/React.createElement(Icon, {
                name: item.iconId
              }),
              exact: true
            });
          }
        }));
      }), this.props.items != null ? this.props.items.map(function (item, index) {
        if (item.parentId != null && item.parentId != '') {
          return null;
        }
        if (item.type != 'EXTERNAL') {
          return null;
        }
        var label = item.text;
        if (label.indexOf('nav_') > -1) {
          label = _this2.linkTexts(item.text);
        }
        return /*#__PURE__*/React.createElement(Menu.Item, {
          key: 'item-' + index,
          label: label,
          to: item.url,
          icon: /*#__PURE__*/React.createElement(Icon, {
            name: item.iconId
          }),
          target: "_blank"
        });
      }) : null, /*#__PURE__*/React.createElement(Menu.Item, {
        label: translate('Help center'),
        to: "https://startvh.haldor.se",
        icon: /*#__PURE__*/React.createElement("img", {
          style: {
            width: "24px"
          },
          src: "/dist/img/help-ico.png",
          alt: "support-icon"
        }),
        target: "_blank"
      }), this.props.students.length > 1 ? /*#__PURE__*/React.createElement("div", {
        className: "select-students"
      }, /*#__PURE__*/React.createElement(Menu.Item, {
        tabIndex: 0,
        onKeyDown: function onKeyDown(event) {
          return event.key == "Enter" ? event.target.click() : null;
        },
        label: "".concat(((_this$props$activeStu = this.props.activeStudent) === null || _this$props$activeStu === void 0 ? void 0 : _this$props$activeStu.firstName) || '', " ").concat(((_this$props$activeStu2 = this.props.activeStudent) === null || _this$props$activeStu2 === void 0 ? void 0 : _this$props$activeStu2.lastName) || '').trim(),
        icon: /*#__PURE__*/React.createElement(Icon, {
          name: "People"
        }),
        items: students,
        badge: notCurrentStudentHaveUnreads ? '' : null
      })) : /*#__PURE__*/React.createElement("div", {
        className: "single-student"
      }, /*#__PURE__*/React.createElement(Menu.Item, {
        label: "".concat(((_this$props$activeStu3 = this.props.activeStudent) === null || _this$props$activeStu3 === void 0 ? void 0 : _this$props$activeStu3.firstName) || '', " ").concat(((_this$props$activeStu4 = this.props.activeStudent) === null || _this$props$activeStu4 === void 0 ? void 0 : _this$props$activeStu4.lastName) || '').trim(),
        icon: /*#__PURE__*/React.createElement(Icon, {
          name: "People"
        })
      })), profile != null ? /*#__PURE__*/React.createElement("div", {
        className: "select-userinfo"
      }, /*#__PURE__*/React.createElement(Menu.Item, {
        tabIndex: 0,
        onKeyDown: function onKeyDown(event) {
          return event.key == "Enter" ? event.target.click() : null;
        },
        label: "".concat((profile === null || profile === void 0 ? void 0 : profile.firstName) || '', " ").concat((profile === null || profile === void 0 ? void 0 : profile.lastName) || '').trim(),
        icon: /*#__PURE__*/React.createElement("img", {
          className: "person",
          src: "/dist/svg/person.svg",
          alt: "person"
        }),
        items: userMenu
      })) : null, displayActiveLanguage != null ? /*#__PURE__*/React.createElement("div", {
        className: "select-language"
      }, /*#__PURE__*/React.createElement(Menu.Item, {
        tabIndex: 0,
        onKeyDown: function onKeyDown(event) {
          return event.key == "Enter" ? event.target.click() : null;
        },
        label: displayActiveLanguage.label,
        icon: /*#__PURE__*/React.createElement("img", {
          className: "flag",
          src: displayActiveLanguage.svg_src,
          alt: displayActiveLanguage.label
        }),
        items: languageMenu
      })) : null);
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    user: state.User.user,
    activeStudent: state.User.activeStudent,
    students: state.guardians.students,
    student: state.User.activeStudent,
    activeSchool: state.User.activeSchool,
    location: document.location.pathname,
    items: state.Menu.items,
    profile: state.profile.profile,
    translate: translate(state.Languages.translations),
    unreadNotifications: state.Notifications.unreadNotifications
  };
}
export default withRouter(connect(mapStateToProps, {
  setActiveStudent: setActiveStudent,
  getUnreadNotifications: getUnreadNotifications,
  setActiveSchool: setActiveSchool,
  getProfileInformation: getProfileInformation,
  putProfileInformation: putProfileInformation
})(AppMenu));